var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"connect_btn",on:{"click":function($event){return _vm.handleAuthClick()}}},[_vm._v("Connect to Google Drive")]),_c('div',{attrs:{"id":"content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }